import { render } from "./NavbarMobile.vue?vue&type=template&id=0bdaf57d&scoped=true"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"

import "./NavbarMobile.vue?vue&type=style&index=0&id=0bdaf57d&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdaf57d"]])

export default __exports__